import { render, staticRenderFns } from "./ImportBudgetHelp.vue?vue&type=template&id=99d02b3e&scoped=true"
import script from "./ImportBudgetHelp.vue?vue&type=script&lang=js"
export * from "./ImportBudgetHelp.vue?vue&type=script&lang=js"
import style0 from "./ImportBudgetHelp.vue?vue&type=style&index=0&id=99d02b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d02b3e",
  null
  
)

export default component.exports